<div class="__wrapper u-flex-column u-margin-top-double">
    <img height="auto" width="110" src="/assets/images/smooved-logo.png" />
    <div class="u-flex-row u-flex-justify-content-space-between">
        <span class="u-flex u-flex-align-items-end u-font-size-13 u-weight-normal u-color-gray-darkest">Smooved bv - BE0722.904.277</span>
        <div class="u-flex u-flex-align-items-center">
            <a [href]="socialsUriSmooved.linkedIn" target="_blank">
                <app-icon [brand]="brands.LinkedIn" [size]="uiIconSize.Md" [context]="uiContext.Muted"></app-icon>
            </a>
            <a [href]="socialsUriSmooved.facebook" target="_blank">
                <app-icon
                    class="u-margin-left-half"
                    [brand]="brands.Facebook"
                    [size]="uiIconSize.Md"
                    [context]="uiContext.Muted"
                ></app-icon>
            </a>
            <a [href]="socialsUriSmooved.twitter" target="_blank">
                <app-svg-illustration class="__x-logo u-margin-left-half" [svg]="svgIllustration.xLogo"></app-svg-illustration>
            </a>
        </div>
    </div>
</div>
